import { render, staticRenderFns } from "./pbxServerForm.vue?vue&type=template&id=53b17ebc"
import script from "./pbxServerForm.vue?vue&type=script&lang=js"
export * from "./pbxServerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports